import styled from "styled-components";

export const StyledQuizCard = styled.div`
  background: ${props => props.theme.transparentBackground};
  padding: 1em;
  border-radius: 0.5em;
  min-height: 250px;
  display: flex;
  flex-direction: column !important;
`;


// WEBPACK FOOTER //
// ./src/components/QuizBox/StyledQuizCard.tsx